(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCharts', sodCharts);

    function sodCharts($document, lodash) {
        return {
            restrict: 'E',
            bindToController: true,
            controller: sodChartsCtrl,
            controllerAs: 'vm',
            templateUrl: 'common/components/sod-charts',
            scope: {
                layout: '=',
            },
        };
    }

    function sodChartsCtrl(GenericModel, lodash, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            init();
        }

        function init() {
            initChartGridOption();
        }

        function initChartGridOption() {
            vm.chartGridOption = { data: vm.layout };



            lodash.forEach(
                lodash.get(vm, 'chartGridOption.data', []),
                function (oData, oDataIndex) {
                    callRemoteApi(lodash.get(oData, 'data.datasource'))
                        .then(function (res) {
                            lodash.set(vm, 'chartGridOption.data[' + oDataIndex + '].chartConfig', res);
                            renderChart(oDataIndex);
                        });
                }
            );
        }

        function renderChart(chartIndex) {
            const chart_config = vm.chartGridOption.data[chartIndex];


            let c3_options = {
                bindto: '#' + chart_config.name +'-' + chartIndex,
                onresize: (function(chartIndex) {
                    return function() {
                        c3ChartResize(chartIndex);
                    };
                })(chartIndex),
            };

            c3_options = lodash.extend(c3_options, lodash.get(vm, 'chartGridOption.data[' + chartIndex + '].chartConfig', {}));




            const c3Chart = c3.generate(c3_options);

            lodash.set(vm, 'chartGridOption.data[' + chartIndex + '].c3Chart', c3Chart);

            $timeout((function(chartIndex) {
                return function() {
                    c3ChartResize(chartIndex);
                };
            })(chartIndex), 300);
        }

        function c3ChartResize(chartIndex) {
            const chart_config = vm.chartGridOption.data[chartIndex];
            const c3Chart = lodash.get(vm, 'chartGridOption.data[' + chartIndex + '].c3Chart', {});

            const cardMainContentElement = $('#' + chart_config.name + '-' + chartIndex)[0];
            const cardMainContentElementWidth = cardMainContentElement.offsetWidth;

            const cardElement = cardMainContentElement.parentElement.parentElement;
            const cardElementChildren = cardElement.children;

            const cardElementHeight = cardElement.clientHeight;
            let cardContentHeight = cardElementHeight;
            for(let i = 0; i < cardElementChildren.length; i++) {
                const isCardMainContent = cardElementChildren[i].className.indexOf('card-main-content') >= 0;
                if (!isCardMainContent) {
                    cardContentHeight -= cardElementChildren[i].clientHeight;
                }
            }

            c3Chart.resize({
                width: cardMainContentElementWidth,
                height: cardContentHeight * 0.9,
            });
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    // return res.data;
                    return additionalSettings(res.data);
                } else {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }


        function additionalSettings(chart_option) {
            var type = lodash.get(chart_option, 'data.type', 'line');
            switch (type) {
                case 'pie':
                    lodash.set(chart_option, 'pie.label.format', function(value, ratio, id) {
                        return value;
                    });
                    break;
                case 'line':
                    // lodash.set(chart_option, 'axis.y.tick.count', 1);
                    lodash.set(chart_option, 'axis.x.tick.rotate', -75);
                    break;
            }
            return chart_option;
        }
    }
})();